import { useQuery } from '@apollo/client';
import { isEmpty, isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useViewTemplate(
  workflowTemplateId?: string | null,
  viewTemplateId?: string | null,
): {
  viewTemplate?: MBAPI.ViewTemplate;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    MBAPI.GetViewTemplateQuery,
    MBAPI.GetViewTemplateQueryVariables
  >(Queries.viewTemplate.getViewTemplate, {
    variables: {
      input: {
        workflowTemplateId: workflowTemplateId ?? '',
        id: viewTemplateId ?? '',
      },
    },
    skip: isNil(workflowTemplateId) || isEmpty(viewTemplateId),
  });

  return {
    viewTemplate: data?.getViewTemplate,
    loading,
    error,
  };
}
